import { render, staticRenderFns } from "./active-cards.vue?vue&type=template&id=a2f0d74e"
import script from "./active-cards.vue?vue&type=script&lang=js"
export * from "./active-cards.vue?vue&type=script&lang=js"
import style0 from "./active-cards.vue?vue&type=style&index=0&id=a2f0d74e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports